import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import queryString from 'query-string';

// Services
import API from 'API';
import TextHelpers from 'helpers/TextHelpers';
import ReferenceHelpers from 'helpers/ReferenceHelpers';

// Components
import DatePicker from 'components/common/DatePicker';
import SuperTable from 'components/common/SuperTable';
import Loader from 'components/common/Loader';
import SearchBox from 'components/common/SearchBox';
import EditCustomerModal from 'components/customer/EditCustomerModal';

//-----------------------------------------------------------------

class ListCustomers extends React.Component {

    constructor(props) {
        super(props);

        this.editCustomerModalRef = React.createRef();

        this.state = {
            filters: {},
            customers: [],
            isAdvancedSearch: false,
            chimneyTypes: [],
            priceSchemes: []
        };
    }
    
    componentDidMount() {
        this.props.fns.setTitle('Customers');

        // Load from querystring
        const qs = queryString.parse(this.props.history.location.search);
        if (qs.customerID) {
            this.open({ id: qs.customerID });
        }
    }

    componentDidUpdate(oldProps) {
        if (this.props.type != oldProps.type) {
            this.runBasicSearch(this.state.query);
        }
    }

    async add() {
        await this.editCustomerModalRef.current.open({
            cameFrom: 'customers'
        });
        if (this.state.isAdvancedSearch) {
            this.runAdvancedSearch();
        } else {
            this.runBasicSearch(this.state.query);
        }
    }

    async open(c) {
        let propertyID;
        
        if (c.property) {
            propertyID = c.property.id;
        }
        
        await this.editCustomerModalRef.current.open({
            id: c.id,
            propertyID,
            cameFrom: 'customers'
        });
        if (this.state.isAdvancedSearch) {
            this.runAdvancedSearch();
        } else {
            this.runBasicSearch(this.state.query);
        }
    }

    toggleAdvancedSearch() {
        if (this.state.isAdvancedSearch) {
            this.setState({
                isAdvancedSearch: false,
                customers: []
            });
        } else {
            this.setState({
                isAdvancedSearch: true,
                isLoadingFilters: true,
                customers: []
            }, () => {
                this.loadFilters();
            });
        }
    }

    async loadFilters() {
        const [chimneyTypes, priceSchemes] = await Promise.all([
            API.call('chimney-type/list'),
            API.call('price-scheme/list')
        ]);
        this.setState({
            chimneyTypes,
            priceSchemes,
            isLoadingFilters: false
        });
    }

    updateFilters(newValues) {
        const filters = { ...this.state.filters };
        for (let fieldName in newValues) {
            filters[fieldName] = newValues[fieldName];
        }
        this.setState({ filters });
    }

    async runBasicSearch(query) {
        this.setState({ query });
        const nonce = `${Math.random()}`;
        const response = await API.call('search/customer-property', {
            query,
            isArchived: (
                this.props.type == 'active' ? false :
                this.props.type == 'archive' ? true :
                null
            ),
            nonce,
            getApptDates: true
        });
        if (response.nonce == nonce) {
            this.setState({
                customers: response.results
            });
        }
    }

    async runAdvancedSearch() {
        this.setState({ isLoading: true });
        const results = await API.call('search/customer-property-advanced', {
            ...this.state.filters,
            isArchived: (
                this.props.type == 'active' ? false :
                this.props.type == 'archive' ? true :
                null
            )
        });
        this.setState({
            customers: results,
            isLoading: false
        });
    }

    async showAll() {
        this.setState({ isLoading: true });
        const nonce = `${Math.random()}`;
        const response = await API.call('search/customer-property', {
            query: '',
            isArchived: (
                this.props.type == 'active' ? false :
                this.props.type == 'archive' ? true :
                null
            ),
            showAll: true,
            nonce
        });
        if (response.nonce == nonce) {
            this.setState({
                customers: response.results
            });
        }
        this.setState({ isLoading: false });
    }

    exportToExcel() {
        API.call('customer/export-excel', {
            isDownload: true
        });
    }

    exportSelectedToExcel() {
        API.call('search/customer-property-advanced-excel', {
            ...this.state.filters,
            isArchived: (
                this.props.type == 'active' ? false :
                this.props.type == 'archive' ? true :
                null
            ),
            isDownload: true
        });
    }
    //----------------------------------------------------------------------

    render() {
        const {
            isLoading,
            isAdvancedSearch,
            customers
        } = this.state;
        const { type, loginInfo } = this.props;

        return (<>

            <section className="control-panel">

                {!isAdvancedSearch &&
                    <div className="control-panel-component search-box me-3">
                        <SearchBox
                            className="form-control"
                            placeholder="Search..."
                            minLength={2}
                            autoFocus={true}
                            searchDelay={250}
                            search={(query) => this.runBasicSearch(query)}
                            clear={() => this.setState({ customers: [] })}
                            onClickResult={result => this.props.history.push(`/customer/${result.entityID}`)}
                        />
                    </div>
                }
                <div className="control-panel-component">
                    <button type="button" className="btn btn-secondary" onClick={() => this.toggleAdvancedSearch()}>
                        {isAdvancedSearch ? 'Basic Search' : 'Advanced Search'}
                    </button>
                </div>

                <div className="control-panel-component ms-auto">
                    <div className="dropdown">
                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {
                                type == 'active' ? 'Active' :
                                type == 'archive' ? 'Archive' : 
                                'All'
                            }
                        </button>
                        <ul className="dropdown-menu">
                            {type != 'active' &&
                                <li>
                                    <Link className="dropdown-item" to="/customers/active">Active</Link>
                                </li>
                            }
                            {type != 'archive' &&
                                <li>
                                    <Link className="dropdown-item" to="/customers/archive">Archive</Link>
                                </li>
                            }
                            {type != 'all' &&
                                <li>
                                    <Link className="dropdown-item" to="/customers/all">All</Link>
                                </li>
                            }
                        </ul>
                    </div>
                </div>

                {type != 'archive' &&
                    <div className="control-panel-component">
                        <button type="button" className="ms-auto btn btn-primary" onClick={() => this.add()}>
                            New Customer
                        </button>
                    </div>
                }

                {!!loginInfo.user.headOfficeAccountID &&
                    <div className="control-panel-component">
                        <button type="button" className="ms-auto btn btn-secondary" onClick={() => this.exportToExcel()}>
                            Export all
                        </button>
                    </div>
                }

                {isAdvancedSearch && customers &&
                    <div className="control-panel-component">
                        <button type="button" className="ms-auto btn btn-secondary" onClick={() => this.exportSelectedToExcel()}>
                            Export
                        </button>
                    </div>
                }

            </section>

            {isAdvancedSearch ?
                this.renderAdvancedSearch() :
                this.renderBasicSearch()
            }

            <EditCustomerModal
                {...this.props}
                ref={this.editCustomerModalRef}
            />

        </>);
    }

    renderBasicSearch() {
        const {
            isLoading,
            customers
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }
        return (
            <section>
                {this.renderResults()}
                {(!customers || customers.length == 0) && 
                    <button type="button" className="btn btn-primary list-all-customers-btn" onClick={() => this.showAll()}>
                        List all customers
                    </button>
                }
            </section>
        );
    }


    renderAdvancedSearch() {
        const {
            isLoading,
            customers,
            query
        } = this.state;

        return (
            <div className="advanced-customer-search">

                <section className="left-col">

                    {this.renderAdvancedFilters()}

                </section>

                <section className="right-col">

                    {this.renderResults()}

                </section>

            </div>
        );
    }

    renderAdvancedFilters() {
        const {
            filters,
            chimneyTypes,
            priceSchemes,
            isLoadingFilters
        } = this.state;
        const { type } = this.props;

        if (isLoadingFilters) {
            return (<Loader />);
        }

        return (

            <form onSubmit={e => {
                e.preventDefault();
                this.runAdvancedSearch();
            }}>

                <div className="form-group">
                    <label className="form-label">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        value={filters.name || ''}
                        onChange={e => this.updateFilters({ name: e.target.value })}
                        autoFocus
                    />
                </div>

                {/*
                <div className="row">

                    <Col md="6">


                    </Col>

                    <Col md="6">

                        <div className="form-group">
                            <label className="form-label">Customer Ref</label>
                            <input
                                type="text"
                                className="form-control"
                                value={filters.customerRef || ''}
                                onChange={e => this.updateFilters({ customerRef: e.target.value })}
                            />
                        </div>

                    </Col>

                </div>
                */}

                <div className="form-group">
                    <label className="form-label">Address / Postcode</label>
                    <input
                        type="text"
                        className="form-control"
                        value={filters.address || ''}
                        onChange={e => this.updateFilters({ address: e.target.value })}
                    />
                </div>

                <div className="row">

                    <div className="col-md-6">

                        <div className="form-group">
                            <label className="form-label">Phone</label>
                            <input
                                type="text"
                                className="form-control"
                                value={filters.phone || ''}
                                onChange={e => this.updateFilters({ phone: e.target.value })}
                            />
                        </div>

                    </div>

                    <div className="col-md-6">

                        <div className="form-group">
                            <label className="form-label">Email Address</label>
                            <input
                                type="text"
                                className="form-control"
                                value={filters.emailAddress || ''}
                                onChange={e => this.updateFilters({ emailAddress: e.target.value })}
                            />
                        </div>

                    </div>

                </div>

                <div className="row">

                    <div className="col-md-6">

                        <div className="form-group">
                            <label className="form-label">Last Booking Between...</label>
                            <DatePicker
                                className="form-control"
                                wrapperClassName="date-picker"
                                value={filters.lastApptAfter}
                                onChange={date => this.updateFilters({ lastApptAfter: date })}
                                isClearable
                            />
                        </div>

                    </div>

                    <div className="col-md-6">

                        <div className="form-group">
                            <label className="form-label">...and...</label>
                            <DatePicker
                                className="form-control"
                                wrapperClassName="date-picker"
                                value={filters.lastApptBefore}
                                onChange={date => this.updateFilters({ lastApptBefore: date })}
                                isClearable
                            />
                        </div>

                    </div>

                </div>

                <div className="row">

                    <div className="col-md-6">

                        <div className="form-group">
                            <label className="form-label">Next Booking Between...</label>
                            <DatePicker
                                className="form-control"
                                wrapperClassName="date-picker"
                                value={filters.nextApptAfter}
                                onChange={date => this.updateFilters({ nextApptAfter: date })}
                                isClearable
                            />
                        </div>

                    </div>

                    <div className="col-md-6">

                        <div className="form-group">
                            <label className="form-label">...and...</label>
                            <DatePicker
                                className="form-control"
                                wrapperClassName="date-picker"
                                value={filters.nextApptBefore}
                                onChange={date => this.updateFilters({ nextApptBefore: date })}
                                isClearable
                            />
                        </div>

                    </div>

                </div>

                <div className="form-group">
                    <label className="form-label">Chimney Type</label>
                    <select
                        className="form-control"
                        value={filters.chimneyTypeID || ''}
                        onChange={e => this.updateFilters({ chimneyTypeID: e.target.value })}
                    >
                        <option value="">(Any)</option>
                        {chimneyTypes.map(ct =>
                            <option key={ct.id} value={ct.id}>
                                {ct.name}
                            </option>
                        )}
                    </select>
                </div>

                <div className="form-group">
                    <label className="form-label">Price Scheme</label>
                    <select
                        className="form-control"
                        value={filters.priceSchemeID || ''}
                        onChange={e => this.updateFilters({ priceSchemeID: e.target.value })}
                    >
                        <option value="">(Any)</option>
                        {priceSchemes.map(ps =>
                            <option key={ps.id} value={ps.id}>
                                {ps.name}
                            </option>
                        )}
                    </select>
                </div>

                <div className="form-group">
                    <label className="form-label">Customer Type</label>
                    <select
                        className="form-control"
                        value={filters.customerType || ''}
                        onChange={e => this.updateFilters({ customerType: e.target.value })}
                    >
                        <option value="">(Any)</option>
                        <option value="OwnerOccupier">Owner / Occupier</option>
                        <option value="Tenant">Tenant</option>
                        <option value="LettingAgent">Letting Agent</option>
                        <option value="Estate">Estate</option>
                        <option value="HousingAssociation">Housing Association</option>
                        <option value="Landlord">Landlord</option>
                        <option value="Company">Company</option>
                        <option value="MultiplePropertyOwner">Multiple Property Owner</option>
                    </select>
                </div>

                <button type="submit" className="btn btn-primary w-100 mt-5">
                    Search
                </button>
                
            </form>
        );
    }

    renderResults() {
        const {
            customers,
            query,
            isLoading
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        // Flatten list
        let customersFlattened;
        if (customers && customers.length > 0) {
            customersFlattened = [];
            customers.forEach(c => {
                if (!ReferenceHelpers.isIndividual(c.customerType)) {
                    customersFlattened.push({
                        ...c
                    });
                }
                c.properties.forEach(p => {
                    const customerAndProperty = {
                        ...c,
                        isProperty: true,
                        property: { ...p }
                    };
                    customersFlattened.push(customerAndProperty);
                });
            });
        }

        return (
            <SuperTable
                className="customers-table table clickable table-bordered clickable mb-0"
                rows={customersFlattened || []}
                keyAccessor={c => `${c.id}-${c.property ? c.property.id : 'company'}`}
                cols={{
                    name: {
                        label: 'Name',
                        getValue: (colInfo, customer) => {
                            const lines = [
                                customer.name,
                                customer.companyName ? 'Company: ' + customer.companyName : ''
                            ];
                            return lines.filter(l => !!l).map((l, index) =>
                                <div key={index}>{TextHelpers.formatHighlightedText(l)}</div>
                            );
                        }
                    },
                    //reference: {
                    //    label: 'Unique Ref',
                    //    getValue: (colInfo, c) => {
                    //        return TextHelpers.formatHighlightedText(c.reference);
                    //    }
                    //},
                    address: {
                        label: 'Property',
                        getValue: (colInfo, c) => {
                            if (c.property) {
                                return TextHelpers.formatHighlightedText(c.property.address);
                            } else {
                                return 'Multiple properties';
                            }
                        }
                    },
                    lastApptDate: {
                        label: 'Last Appt',
                        type: 'date',
                        getValue: (colInfo, c) => {
                            if (c.property && c.property.lastApptDate) {
                                return moment(c.property.lastApptDate).format('DD/MM/YYYY');
                            }
                        }
                    },
                    nextApptDate: {
                        label: 'Next Appt',
                        type: 'date',
                        getValue: (colInfo, c) => {
                            if (c.property && c.property.nextApptDate) {
                                return moment(c.property.nextApptDate).format('DD/MM/YYYY');
                            }
                        }
                    }
                }}
                onClick={(c, e) => this.open(c)}
                emptyText={customersFlattened && customersFlattened.length == 0 ?
                    'No matching customers or properties' : 'Please enter a search query'}
            />
        );
    }

}

export default ListCustomers;